import type {ReactElement} from 'react';
import {AiChatBody} from '@AiChat/components/ai-chat-body/ai-chat-body';
import {AiChatLoadingStates} from '@AiChat/components/ai-chat-loading-states/ai-chat-loading-states';
import type {AiChatConversationProps} from '@AiChat/components/ai-chat-conversation/ai-chat-conversation.types';

export function AiChatConversation({className, children, ...props}: AiChatConversationProps): ReactElement {
  return (
    <div className={`_position-relative ${className ?? ''}`}>
      <AiChatLoadingStates />
      <AiChatBody {...props} />
      {children}
    </div>
  );
}
